import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import i18n from './translations/i18n'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import { BreadcrumbsProvider } from 'react-breadcrumbs-dynamic'
import { ConfirmationModal } from './shared/modal/ConfirmationModal'
import TagManager from 'react-gtm-module'

TagManager.initialize({
    gtmId: 'GTM-KGMZGT8D', // replace with your GTM container ID
})

const root = createRoot(document.getElementById('root')!)

root.render(
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <BrowserRouter>
                <ConfirmationModal>
                    <BreadcrumbsProvider>
                        <App />
                    </BreadcrumbsProvider>
                </ConfirmationModal>
            </BrowserRouter>
        </I18nextProvider>
    </React.StrictMode>
)
